"use strict";
import { useCallback } from "react";
import {
  ApplicationModal,
  addSuppressedPopups,
  removeSuppressedPopups,
  setCloseModal,
  setOpenModal
} from "state/application/reducer";
import { useAppDispatch, useAppSelector } from "state/hooks";
export function useModalIsOpen(modal) {
  const openModal = useAppSelector((state) => state.application.openModal?.name);
  return openModal === modal;
}
export function useToggleModal(modal) {
  const isOpen = useModalIsOpen(modal);
  const dispatch = useAppDispatch();
  return useCallback(() => {
    if (isOpen) {
      dispatch(setCloseModal(modal));
    } else {
      dispatch(setOpenModal({ name: modal }));
    }
  }, [dispatch, modal, isOpen]);
}
export function useCloseModal(modal) {
  const dispatch = useAppDispatch();
  return useCallback(() => dispatch(setCloseModal(modal)), [dispatch, modal]);
}
export function useOpenModal(modal) {
  const dispatch = useAppDispatch();
  return useCallback(() => dispatch(setOpenModal(modal)), [dispatch, modal]);
}
export function useToggleSettingsMenu() {
  return useToggleModal(ApplicationModal.SETTINGS);
}
export function useShowClaimPopup() {
  return useModalIsOpen(ApplicationModal.CLAIM_POPUP);
}
export function useToggleShowClaimPopup() {
  return useToggleModal(ApplicationModal.CLAIM_POPUP);
}
export function useTogglePrivacyPolicy() {
  return useToggleModal(ApplicationModal.PRIVACY_POLICY);
}
export function useSuppressPopups(popupTypes) {
  const dispatch = useAppDispatch();
  const suppressPopups = useCallback(() => dispatch(addSuppressedPopups({ popupTypes })), [dispatch, popupTypes]);
  const unsuppressPopups = useCallback(() => dispatch(removeSuppressedPopups({ popupTypes })), [dispatch, popupTypes]);
  return {
    suppressPopups,
    unsuppressPopups
  };
}
